import React, {useContext} from "react"
import DataContext from "../../context/DataContext"
import AllBikesCollection from "../bikesCollection/AllBikesCollection"
import FilterContext from "../../context/FilterContext"

function BasedOnYourViews() {
	const {customBikeRecommendations} = useContext(DataContext)
	const {filtersLoading} = useContext(FilterContext)

	if (customBikeRecommendations?.length) {
		return (<AllBikesCollection
			filteredBikes={customBikeRecommendations}
			isLoadingMoreProducts={false}
			filtersLoading={filtersLoading}
			bikesList={customBikeRecommendations}
		/>
		)
	}

	return null
}

export default BasedOnYourViews
